<nb-card>
  <nb-card-header>
    Add a new integration key
  </nb-card-header>
  <nb-card-body>
    <button (click)="addUser()" nbButton status="success">Add</button>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    Integration key
  </nb-card-header>
  <nb-card-body>
    <angular2-smart-table [settings]="settings" [source]="source" (deleteConfirm)="onDeleteConfirm($event)">
    </angular2-smart-table>
  </nb-card-body>
</nb-card>
